// Note: Filter option value can be undefined in range input filter option
export type FilterOptionValue = string | number | undefined;

export enum EventCategory {
  Filters = 'Filters',
  QuickFilters = 'Quick filters',
}

export interface SelectedFilterOption {
  selectedByDefault?: boolean;
  // Store both Filter uid and FilterOption uid if exists.
  // If FilterOption uid exists, this should be used for API calls.
  // (e.g. for range where there is filter[price_at_least] and filter[price_at_most])
  filterUid: string;
  filterOptionUid?: string;
  // Array of FilterOptionValues used for checkbox group
  filterOptionValue: FilterOptionValue | FilterOptionValue[];
  filterOptionDepth?: number;
  eventCategory?: EventCategory;
}

export type FilterInputType = 'checkbox' | 'radio' | 'range' | 'tree';

export interface FilterOption {
  uid?: string;
  active?: boolean;
  tooltip?: string;
  title: string;
  value?: FilterOptionValue;
  valueTextPrefix?: string;
  minValue?: number;
  maxValue?: number;
  activeCount: number | null;
}

export interface TreeFilterOption extends FilterOption {
  depth: number;
}

export interface Filter {
  uid: string;
  title: string;
  type: FilterInputType;
  active: boolean;
  expandedByDefault: boolean;
  options: FilterOption[];
  defaultOption?: number;
}
